/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Filetoggle_Viewonly4Inputs */

const en_coinvestments_dataroom_filetoggle_viewonly4 = /** @type {(inputs: Coinvestments_Dataroom_Filetoggle_Viewonly4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View only`)
};

/**
* | output |
* | --- |
* | "View only" |
*
* @param {Coinvestments_Dataroom_Filetoggle_Viewonly4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetoggle_viewonly4 = /** @type {((inputs?: Coinvestments_Dataroom_Filetoggle_Viewonly4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetoggle_Viewonly4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetoggle_viewonly4(inputs)
});
export { coinvestments_dataroom_filetoggle_viewonly4 as "coInvestments_dataRoom_fileToggle_viewOnly" }